// Shared country codes used across Registration, SetupAccount, and Profile pages
// Organized by region for easy scanning

const COUNTRY_CODES = [
  // South Asia
  { code: '91', label: 'IN +91', flag: '\u{1F1EE}\u{1F1F3}', country: 'India' },
  { code: '92', label: 'PK +92', flag: '\u{1F1F5}\u{1F1F0}', country: 'Pakistan' },
  { code: '880', label: 'BD +880', flag: '\u{1F1E7}\u{1F1E9}', country: 'Bangladesh' },
  { code: '94', label: 'LK +94', flag: '\u{1F1F1}\u{1F1F0}', country: 'Sri Lanka' },
  { code: '977', label: 'NP +977', flag: '\u{1F1F3}\u{1F1F5}', country: 'Nepal' },
  // Middle East
  { code: '971', label: 'AE +971', flag: '\u{1F1E6}\u{1F1EA}', country: 'UAE' },
  { code: '966', label: 'SA +966', flag: '\u{1F1F8}\u{1F1E6}', country: 'Saudi Arabia' },
  { code: '974', label: 'QA +974', flag: '\u{1F1F6}\u{1F1E6}', country: 'Qatar' },
  { code: '973', label: 'BH +973', flag: '\u{1F1E7}\u{1F1ED}', country: 'Bahrain' },
  { code: '968', label: 'OM +968', flag: '\u{1F1F4}\u{1F1F2}', country: 'Oman' },
  { code: '965', label: 'KW +965', flag: '\u{1F1F0}\u{1F1FC}', country: 'Kuwait' },
  { code: '962', label: 'JO +962', flag: '\u{1F1EF}\u{1F1F4}', country: 'Jordan' },
  { code: '972', label: 'IL +972', flag: '\u{1F1EE}\u{1F1F1}', country: 'Israel' },
  { code: '90', label: 'TR +90', flag: '\u{1F1F9}\u{1F1F7}', country: 'Turkey' },
  // Europe
  { code: '44', label: 'UK +44', flag: '\u{1F1EC}\u{1F1E7}', country: 'United Kingdom' },
  { code: '49', label: 'DE +49', flag: '\u{1F1E9}\u{1F1EA}', country: 'Germany' },
  { code: '33', label: 'FR +33', flag: '\u{1F1EB}\u{1F1F7}', country: 'France' },
  { code: '39', label: 'IT +39', flag: '\u{1F1EE}\u{1F1F9}', country: 'Italy' },
  { code: '34', label: 'ES +34', flag: '\u{1F1EA}\u{1F1F8}', country: 'Spain' },
  { code: '31', label: 'NL +31', flag: '\u{1F1F3}\u{1F1F1}', country: 'Netherlands' },
  { code: '46', label: 'SE +46', flag: '\u{1F1F8}\u{1F1EA}', country: 'Sweden' },
  { code: '47', label: 'NO +47', flag: '\u{1F1F3}\u{1F1F4}', country: 'Norway' },
  { code: '45', label: 'DK +45', flag: '\u{1F1E9}\u{1F1F0}', country: 'Denmark' },
  { code: '48', label: 'PL +48', flag: '\u{1F1F5}\u{1F1F1}', country: 'Poland' },
  { code: '380', label: 'UA +380', flag: '\u{1F1FA}\u{1F1E6}', country: 'Ukraine' },
  { code: '41', label: 'CH +41', flag: '\u{1F1E8}\u{1F1ED}', country: 'Switzerland' },
  { code: '43', label: 'AT +43', flag: '\u{1F1E6}\u{1F1F9}', country: 'Austria' },
  { code: '32', label: 'BE +32', flag: '\u{1F1E7}\u{1F1EA}', country: 'Belgium' },
  { code: '353', label: 'IE +353', flag: '\u{1F1EE}\u{1F1EA}', country: 'Ireland' },
  { code: '351', label: 'PT +351', flag: '\u{1F1F5}\u{1F1F9}', country: 'Portugal' },
  { code: '30', label: 'GR +30', flag: '\u{1F1EC}\u{1F1F7}', country: 'Greece' },
  { code: '420', label: 'CZ +420', flag: '\u{1F1E8}\u{1F1FF}', country: 'Czech Republic' },
  { code: '40', label: 'RO +40', flag: '\u{1F1F7}\u{1F1F4}', country: 'Romania' },
  { code: '36', label: 'HU +36', flag: '\u{1F1ED}\u{1F1FA}', country: 'Hungary' },
  { code: '358', label: 'FI +358', flag: '\u{1F1EB}\u{1F1EE}', country: 'Finland' },
  // North America
  { code: '1', label: 'US +1', flag: '\u{1F1FA}\u{1F1F8}', country: 'United States' },
  { code: '1CA', label: 'CA +1', flag: '\u{1F1E8}\u{1F1E6}', country: 'Canada' },
  { code: '52', label: 'MX +52', flag: '\u{1F1F2}\u{1F1FD}', country: 'Mexico' },
  // South America
  { code: '55', label: 'BR +55', flag: '\u{1F1E7}\u{1F1F7}', country: 'Brazil' },
  { code: '54', label: 'AR +54', flag: '\u{1F1E6}\u{1F1F7}', country: 'Argentina' },
  { code: '56', label: 'CL +56', flag: '\u{1F1E8}\u{1F1F1}', country: 'Chile' },
  { code: '57', label: 'CO +57', flag: '\u{1F1E8}\u{1F1F4}', country: 'Colombia' },
  { code: '51', label: 'PE +51', flag: '\u{1F1F5}\u{1F1EA}', country: 'Peru' },
  // JAPAC
  { code: '81', label: 'JP +81', flag: '\u{1F1EF}\u{1F1F5}', country: 'Japan' },
  { code: '86', label: 'CN +86', flag: '\u{1F1E8}\u{1F1F3}', country: 'China' },
  { code: '82', label: 'KR +82', flag: '\u{1F1F0}\u{1F1F7}', country: 'South Korea' },
  { code: '65', label: 'SG +65', flag: '\u{1F1F8}\u{1F1EC}', country: 'Singapore' },
  { code: '60', label: 'MY +60', flag: '\u{1F1F2}\u{1F1FE}', country: 'Malaysia' },
  { code: '66', label: 'TH +66', flag: '\u{1F1F9}\u{1F1ED}', country: 'Thailand' },
  { code: '84', label: 'VN +84', flag: '\u{1F1FB}\u{1F1F3}', country: 'Vietnam' },
  { code: '62', label: 'ID +62', flag: '\u{1F1EE}\u{1F1E9}', country: 'Indonesia' },
  { code: '63', label: 'PH +63', flag: '\u{1F1F5}\u{1F1ED}', country: 'Philippines' },
  { code: '61', label: 'AU +61', flag: '\u{1F1E6}\u{1F1FA}', country: 'Australia' },
  { code: '64', label: 'NZ +64', flag: '\u{1F1F3}\u{1F1FF}', country: 'New Zealand' },
  { code: '852', label: 'HK +852', flag: '\u{1F1ED}\u{1F1F0}', country: 'Hong Kong' },
  { code: '886', label: 'TW +886', flag: '\u{1F1F9}\u{1F1FC}', country: 'Taiwan' },
  // Africa
  { code: '27', label: 'ZA +27', flag: '\u{1F1FF}\u{1F1E6}', country: 'South Africa' },
  { code: '234', label: 'NG +234', flag: '\u{1F1F3}\u{1F1EC}', country: 'Nigeria' },
  { code: '254', label: 'KE +254', flag: '\u{1F1F0}\u{1F1EA}', country: 'Kenya' },
  { code: '20', label: 'EG +20', flag: '\u{1F1EA}\u{1F1EC}', country: 'Egypt' },
];

export const isIndianCode = (code) => code === '91';
export default COUNTRY_CODES;
